import { Card, CardBody, Col } from "reactstrap";
import { BorderColor } from "../../../../Constant";
import { BORDER_COLORS, BORDER_COLOR_DATA } from "../../../../Data/UiKit/HelperClasses";
import CommonCardHeader from "../../../../Common/CommonCardHeader";

const BorderColorCart = () => {
  return (
    <Col xs="12">
      <Card>
        <CommonCardHeader title={BorderColor} span={BORDER_COLOR_DATA} />
        <CardBody>
          <div className="gradient-border">
            <div className="d-flex align-items-center mb-2 gap-2">
              <div className="helper-box b-primary border fill-wrapper"> </div>.b-primary
            </div>
            {BORDER_COLORS.map((item, index) => (
              <div className="d-flex align-items-center mb-2 gap-2" key={index}>
                <div className={`helper-box ${item} border fill-wrapper`}> </div>.{item}
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BorderColorCart;